/**
 * 서버 오류를 사용자의 언어로 — 응답의 `errorType`(코드)을 번역하고, 없으면 서버가 준 문장을 그대로 쓴다.
 *
 * 서버는 `{"detail": "<한국어 문장>", "errorType": "canvas.noTasks", "errorParams": {...}}` 를 보낸다
 * (backend/app/errors.py). 코드가 있으면 `error` 네임스페이스에서 찾고, 없으면(옛 서버·프록시 오류·
 * 서버가 아직 코드를 안 단 자리) detail 을 그대로 보여 준다 — 화면이 비어 버리지 않게.
 */
import i18n from '../i18n';

export interface ErrorBody {
  detail?: unknown;
  errorType?: unknown;
  errorParams?: unknown;
}

/** 응답 본문 → 보여 줄 문장. 코드가 번역에 없으면 서버 문장으로 되돌아간다 */
export function errorText(body: ErrorBody | null | undefined, fallback = ''): string {
  const code = body && typeof body.errorType === 'string' ? body.errorType : '';
  if (code) {
    const key = `error:${code}`;
    if (i18n.exists(key)) {
      const params = (body?.errorParams && typeof body.errorParams === 'object') ? body.errorParams as Record<string, unknown> : {};
      return String(i18n.t(key, params as any));
    }
  }
  const detail = body?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  // FastAPI 의 요청 검증 오류는 detail 이 배열이다 — 첫 줄만 보여 준다
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0] as { msg?: unknown };
    if (first && typeof first.msg === 'string') return first.msg;
  }
  return fallback;
}

/** fetch 응답 → 던질 Error. 본문을 못 읽으면 상태 줄로 (호출자가 매번 try/catch 를 쓰지 않도록) */
export async function errorFromResponse(res: Response, fallback = ''): Promise<Error> {
  let body: ErrorBody | null = null;
  try { body = await res.json(); } catch { /* 본문이 없거나 JSON 이 아니다 */ }
  return new Error(errorText(body, fallback || res.statusText || `HTTP ${res.status}`));
}
